import graphClient from '@/api/graph';
import { ApolloQueryResult, gql, useQuery, useSubscription } from '@apollo/client';

export enum TTDUploadStatus {
    Processing = 'Processing',
    Completed = 'Completed',
    Failed = 'Failed',
    Deleted = 'Deleted',
}


export type TTDUpload = {
    id: number
    file_name: string
    upload_date: string
    rows: string
    output_file: string
    uploaded_by: string
    status: TTDUploadStatus
    errors: string
    processed_count: number;
    finished_at: string;
    total_rows: number;
};

const ttdUploadFields = gql`
    fragment ttdUploadFields on ttd_uploads {
        id
        file_name
        upload_date
        rows
        output_file
        uploaded_by
        status
        errors
        processed_count
        finished_at
        total_rows
    }
`;

export const GET_FILE_UPLOADS = gql`
    query getFileUploads {
        items:ttd_uploads(limit: 5, order_by: {upload_date: desc}, where: {status: {_neq: "Deleted"}, is_dev: {_neq: true}}) {
        ...ttdUploadFields
      }
    }
    ${ttdUploadFields}
`;

export const FILE_UPLOAD_STATUS_SUBSCRIPTION = gql`
    subscription fileUploadStatus {
      items:ttd_uploads(limit: 5, order_by: {upload_date: desc}, where: {status: {_neq: "Deleted"}, is_dev: {_neq: true}}) {
        ...ttdUploadFields
      }
    }
    ${ttdUploadFields}
`;

export default async (): Promise<TTDUpload[]> => {
    const { data } = await graphClient.query({
        query: GET_FILE_UPLOADS,
    });
    return data.items;
};

export const useGetFileUploads = (): [TTDUpload[], () => Promise<ApolloQueryResult<any>>] => {
    const { data, refetch } = useQuery(GET_FILE_UPLOADS, {
        fetchPolicy: 'cache-and-network'
    });
    const items = data?.items || [];
    return [ items, refetch ];
};

export const useFileUploadStatusSubscription = (callback: () => void): void => {
    useSubscription(FILE_UPLOAD_STATUS_SUBSCRIPTION, {
        onSubscriptionData: () => {
            callback();
        },
    });
};
